import { State } from '@/components/atoms';

interface EmptyStateProps {
  onAskSellyt: () => void;
}

export const EmptyState = ({ onAskSellyt }: EmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center h-full py-32 px-4">
      <State
        heading="No articles found"
        description="We couldn't find any articles matching your search. Try different keywords or ask Sellyt directly for help."
        button={{
          text: 'Ask Sellyt',
          onClick: onAskSellyt,
        }}
      />
    </div>
  );
};
